import React from "react";
import "./TeamcenterIntegrationforCAM.css";
import TeamcenterIntegrationforCAMOverview from "./TeamcenterIntegrationforCAMOverview";
import Letsgetintouch from "../BusinessProcessAndChangeManagement/Letsgetintouch";
import BannerImage from "../../../assets/other_image/intigretion.jpg";
import Banner from "../Banner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const TeamcenterIntegrationforCAM = () => {
  return (
    <>
      {/* ✅ Meta Tags for SEO */}
      <Helmet>
        <title>Teamcenter CAM Integration Services in Pune | NexTech PLM</title>
        <meta
          name="description"
          content="Streamline manufacturing with Teamcenter CAM Integration in Pune, India. Nextech PLM helps optimize your PLM workflows."
        />
        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        />
      </Helmet>

      <section className="TeamcenterIntegrationforCAM-management">
        <Banner
          image={BannerImage} // Pass the image for this page
          heading="Teamcenter Integration for CAM" // Pass the heading text for this page
        />
        <div>
          <FloatingContactUs />
        </div>

        <TeamcenterIntegrationforCAMOverview />

        <section style={{ background: "#f5f7fa" }}>
          <div className="benefits container">
            <h4 className="TeamcenterIntegrationforCAM-page-heading">
              Unlock the Power :
            </h4>
            <h5 className="TeamcenterIntegrationforCAM-subheading">
              Discover the Transformative Benefits of Teamcenter Integration for CAM
              with NexTech!
            </h5>
            <ul className="custom-bullets">
              <li>Effective programming for multi-function and 5 axis machines.</li>
              <li>Minimize the time and cost involved in design changes.</li>
              <li>Handles Complex job requirements. </li>
              <li>Save programming time by automating routine task.</li>
              <li>Maximize use of Manufacturing Resources.</li>
            </ul>
          </div>
        </section>

        <section>
          <div className="solutions container">
            <div className="solutions-content">
              <div className="row">
                {/* Solutions Content */}
                <div className="col-md-6 col-12">
                  <h4 className="TeamcenterIntegrationforCAM-page-heading">
                    Teamcenter Solutions
                  </h4>
                  <ul className="custom-bullets">
                    <li>
                      Advanced programming capabilities for multi-function and 5-axis
                      machines.
                    </li>
                    <li>
                      Efficient handling of complex job requirements, minimizing time
                      and cost for design changes.
                    </li>
                    <li>
                      Automation of routine tasks saves programming time, optimizing
                      resource utilization.
                    </li>
                    <li>
                      Integration of best practices across CAM software activities,
                      ensuring streamlined processes.
                    </li>
                    <li>
                      Expertise in implementing Teamcenter integration for faster
                      development of numeric control programs and models.
                    </li>
                  </ul>
                </div>

                {/* Quick Links Section */}
                <div className="col-md-6 col-12">
                  <div className="quick-links">
                    <h4>Quick Links</h4>
                    <ul>
                      <li>
                        <NavLink to="/teamcenter-manufacturing-data-process-management">
                          Manufacturing Data and Process Management
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-plm-erp-data-process-management">
                          PLM - ERP (SAP, Oracle, HANA) Data and Process Management
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-bom-management">
                          Product BOM and Variability Management
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-community-collaboration">
                          Teamcenter Community Collaboration
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-cybersecurity">
                          Teamcenter Cyber Security
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-cloud-implementation">
                          Teamcenter Implementation on Cloud
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-implementation">
                          Teamcenter Implementation
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-cae-integration">
                          Integration for CAE
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section style={{ background: "#f5f7fa" }}>
          <div className="best-practices container">
            <h4 className="TeamcenterIntegrationforCAM-page-heading">
              Best Practices
            </h4>
            <p className="plmimplementationparagraph">
              We help to enable best practices while performing various activities on CAM
              s/w like launching CAM s/w, Data exchange, CAD for NC Programming, complex
              Part manufacturing, Mold and die machining, full 3D machining simulation,
              High Speed Machining, delivering machine tool value, Production ready output
              to ensure Manufacturers achieve the best solutions.
            </p>
          </div>
        </section>

        <section>
          <div className="why-nextech container">
            <h4 className="TeamcenterIntegrationforCAM-page-heading">
              Why NexTech?
            </h4>
            <h5 className="TeamcenterIntegrationforCAM-subheading">
              For Teamcenter Integration for CAM
            </h5>
            <ul className="custom-bullets">
              <li>
                NexTech offers advanced programming capabilities tailored specifically
                for multi-function and 5-axis machines, ensuring precision and
                efficiency.
              </li>
              <li>
                Our expertise enables efficient handling of complex job requirements,
                minimizing both time and cost associated with design changes.
              </li>
              <li>
                Automation of routine tasks within CAM software saves valuable
                programming time, optimizing resource utilization and enhancing
                productivity.
              </li>
              <li>
                We integrate best practices across CAM software activities, ensuring
                streamlined processes and optimal performance throughout the
                development lifecycle.
              </li>
              <li>
                NexTech specializes in implementing Teamcenter integration, facilitating
                faster development of numeric control programs and models while
                promoting seamless collaboration between designs and manufacturing
                teams.
              </li>
            </ul>
          </div>
        </section>

        <Letsgetintouch />
      </section>
    </>
  );
};

export default TeamcenterIntegrationforCAM;
